// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModel.attributeTypeMap;
    }
}
ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModel.discriminator = undefined;
ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModel.additionalProperties = false;
ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModel.attributeTypeMap = [
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "sourceGroup",
        "baseName": "sourceGroup",
        "type": "string"
    },
    {
        "name": "sourceOfferType",
        "baseName": "sourceOfferType",
        "type": "number"
    },
    {
        "name": "sourceBatchId",
        "baseName": "sourceBatchId",
        "type": "number"
    },
    {
        "name": "sourceTcProgramId",
        "baseName": "sourceTcProgramId",
        "type": "number"
    },
    {
        "name": "destinationGroup",
        "baseName": "destinationGroup",
        "type": "string"
    },
    {
        "name": "destinationOfferType",
        "baseName": "destinationOfferType",
        "type": "number"
    },
    {
        "name": "destinationBatchId",
        "baseName": "destinationBatchId",
        "type": "number"
    },
    {
        "name": "destinationTcProgramId",
        "baseName": "destinationTcProgramId",
        "type": "number"
    },
];
//# sourceMappingURL=extEnrollmentMoveMemberNumberBySurveyQuestionResultModel.js.map